import React, { useEffect } from "react";
import Windows from "./help/windows";
import Mac from "./help/mac";
import Android from "./help/android";
import IOS from "./help/ios";
import { toast } from "react-hot-toast";
import api from "../common/api";
import { clear } from "../common/utils";

const Tutorial = () => {
    const [subLink, setSubLink] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(true);

    const getUserInfo = () => {
        setIsLoading(true);
        toast.promise(
            api("post", "/api/user/info", null),
            {
                loading: "正在加载会员信息",
                success: (response) => {
                    if (response.status) {
                        localStorage.setItem('userInfo', JSON.stringify(response.data));
                        localStorage.setItem('userInfo_expire', Date.now() + 60000);
                        setSubLink(process.env.REACT_APP_LINK + `/sub?token=${response.data.token}`);
                        setIsLoading(false);
                        return "加载成功";
                    } else {
                        if (response.message === "401") {
                            clear();
                            window.location.href = '/login';
                            throw new Error("请重新登录");
                        } else {
                            throw new Error(response.message);
                        }
                    }
                },
                error: (error) => {
                    setIsLoading(false);
                    return error.message;
                }
            }
        );
    };

    useEffect(() => {
        if (localStorage.getItem('userInfo') && localStorage.getItem('userInfo_expire') > Date.now()) {
            const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
            setSubLink(process.env.REACT_APP_LINK + `/sub?token=${storedUserInfo.token}`);
            setIsLoading(false);
        } else {
            getUserInfo();
        }
    }, []);

    return (
        <main className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8 relative">
            <div className="max-w-7xl mx-auto">
                {/* 头部区域 */}
                <section className="mb-16">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">
                            使用教程
                        </h1>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            按照以下步骤设置您的订阅服务，并在任何设备上畅享我们的网络加速服务。
                        </p>
                    </div>
                </section>

                {/* 平台选择区域 */}
                <section className="mb-16">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        <div className="space-y-8">
                            <label htmlFor="windows" className="block transform transition-all duration-300 hover:scale-105">
                                <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 cursor-pointer">
                                    <div className="flex items-center space-x-4">
                                        <div className="p-3 bg-blue-100 rounded-xl">
                                            <svg className="h-8 w-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold text-gray-900">Windows</h3>
                                            <p className="text-gray-500">Windows 系统配置指南</p>
                                        </div>
                                    </div>
                                </div>
                            </label>
                            <Windows subLink={subLink} />

                            <label htmlFor="macos" className="block transform transition-all duration-300 hover:scale-105">
                                <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 cursor-pointer">
                                    <div className="flex items-center space-x-4">
                                        <div className="p-3 bg-gray-100 rounded-xl">
                                            <svg className="h-8 w-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold text-gray-900">macOS</h3>
                                            <p className="text-gray-500">macOS 系统配置指南</p>
                                        </div>
                                    </div>
                                </div>
                            </label>
                            <Mac subLink={subLink} />
                        </div>

                        <div className="space-y-8">
                            <label htmlFor="android" className="block transform transition-all duration-300 hover:scale-105">
                                <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 cursor-pointer">
                                    <div className="flex items-center space-x-4">
                                        <div className="p-3 bg-green-100 rounded-xl">
                                            <svg className="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold text-gray-900">Android</h3>
                                            <p className="text-gray-500">Android 设备配置指南</p>
                                        </div>
                                    </div>
                                </div>
                            </label>
                            <Android subLink={subLink} />

                            <label htmlFor="ios" className="block transform transition-all duration-300 hover:scale-105">
                                <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 cursor-pointer">
                                    <div className="flex items-center space-x-4">
                                        <div className="p-3 bg-gray-100 rounded-xl">
                                            <svg className="h-8 w-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold text-gray-900">iOS</h3>
                                            <p className="text-gray-500">iOS 设备配置指南</p>
                                        </div>
                                    </div>
                                </div>
                            </label>
                            <IOS subLink={subLink} />
                        </div>
                    </div>
                </section>

                {/* 登录指南区域 */}
                <section className="bg-white rounded-2xl shadow-lg p-8 mb-12 transform transition-all duration-300 hover:shadow-xl">
                    <h2 className="text-3xl font-bold mb-8 text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">
                        登录并获取订阅地址
                    </h2>
                    <ol className="space-y-6">
                        <li className="flex items-start space-x-4">
                            <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <span className="text-blue-600 font-semibold">1</span>
                            </div>
                            <p className="text-lg text-gray-600">访问我们的网站并使用您的账户登录。</p>
                        </li>
                        <li className="flex items-start space-x-4">
                            <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <span className="text-blue-600 font-semibold">2</span>
                            </div>
                            <p className="text-lg text-gray-600">进入用户面板后，您可以选择签到以获取每日免费流量，或者选购套餐以获得更多服务。</p>
                        </li>
                        <li className="flex items-start space-x-4">
                            <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <span className="text-blue-600 font-semibold">3</span>
                            </div>
                            <p className="text-lg text-gray-600">在用户面板中找到您的订阅地址，该地址将在配置客户端时使用。</p>
                        </li>
                    </ol>
                </section>

                {/* FAQ区域 */}
                <section className="bg-white rounded-2xl shadow-lg p-8 mb-12 transform transition-all duration-300 hover:shadow-xl">
                    <h2 className="text-3xl font-bold mb-8 text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">
                        相关问题及解答
                    </h2>
                    <div className="space-y-8">
                        <div className="space-y-6">
                            <div className="bg-gray-50 rounded-xl p-6">
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">常见问题</h3>
                                <div className="space-y-6">
                                    <div>
                                        <p className="text-lg font-medium text-gray-900 mb-2">如何获取订阅地址？</p>
                                        <p className="text-gray-600">登录我们的官方网站，在用户面板中即可找到您的订阅地址。</p>
                                    </div>
                                    <div>
                                        <p className="text-lg font-medium text-gray-900 mb-2">为什么我无法连接到服务器？</p>
                                        <p className="text-gray-600">请确保您输入的订阅地址正确，并尝试更新订阅获取最新的服务器列表。</p>
                                    </div>
                                    <div>
                                        <p className="text-lg font-medium text-gray-900 mb-2">如何更换服务器？</p>
                                        <p className="text-gray-600">在客户端的服务器列表中选择一个新的服务器，并点击连接。</p>
                                    </div>
                                    <div>
                                        <p className="text-lg font-medium text-gray-900 mb-2">流量没用完也没过期，为什么提示用完或过期？</p>
                                        <p className="text-gray-600">订阅地址改变了，需要重新复制面板中的地址。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 联系方式区域 */}
                <section className="bg-white rounded-2xl shadow-lg p-8 transform transition-all duration-300 hover:shadow-xl">
                    <div className="text-center space-y-4">
                        <p className="text-lg text-gray-600">如果您有任何疑问或需要帮助，请联系我们的客服。</p>
                        {process.env.REACT_APP_TG_GROUP && (
                            <div className="inline-flex items-center space-x-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full">
                                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69.01-.03.01-.14-.07-.2-.08-.06-.19-.04-.27-.02-.12.02-1.96 1.25-5.54 3.69-.52.36-1 .53-1.42.52-.47-.01-1.37-.26-2.03-.48-.82-.27-1.47-.42-1.42-.88.03-.24.29-.49.8-.75 3.12-1.36 5.2-2.26 6.24-2.7 2.98-1.25 3.6-1.47 4.01-1.47.09 0 .28.02.4.09.11.06.18.14.21.25.02.1.01.21 0 .23z" />
                                </svg>
                                <span>Telegram Group: @{process.env.REACT_APP_TG_GROUP}</span>
                            </div>
                        )}
                        {process.env.REACT_APP_TG_CHANNEL && (
                            <div className="inline-flex items-center space-x-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full">
                                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69.01-.03.01-.14-.07-.2-.08-.06-.19-.04-.27-.02-.12.02-1.96 1.25-5.54 3.69-.52.36-1 .53-1.42.52-.47-.01-1.37-.26-2.03-.48-.82-.27-1.47-.42-1.42-.88.03-.24.29-.49.8-.75 3.12-1.36 5.2-2.26 6.24-2.7 2.98-1.25 3.6-1.47 4.01-1.47.09 0 .28.02.4.09.11.06.18.14.21.25.02.1.01.21 0 .23z" />
                                </svg>
                                <span>Telegram Channel: @{process.env.REACT_APP_TG_CHANNEL}</span>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </main>
    );
};

export default Tutorial;
